export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const BRAND = "STUDIO WEB NS";
export let EMAIL = "info@studiowebns.it";
export let PHONE = "+39 344 482 1886";
export let PHONE_TEL = "+393444821886";
export let WA_NUMBER = "393444821886";

export function setContact({ phone, email, whatsapp }) {
  if (phone) { PHONE = phone; PHONE_TEL = `+${phone.replace(/\D/g, "")}`; }
  if (email) EMAIL = email;
  if (whatsapp) WA_NUMBER = whatsapp.replace(/\D/g, "");
}

const WA_MESSAGES = {
  preventivo: "Ciao Studio Web NS, vorrei ricevere un preventivo per la mia attività.",
  siti: "Ciao Studio Web NS, vorrei informazioni sulla realizzazione di un sito web.",
  crm: "Ciao Studio Web NS, vorrei informazioni sui vostri servizi CRM.",
  social: "Ciao Studio Web NS, vorrei informazioni sulla gestione dei social.",
  consulenza: "Ciao Studio Web NS, vorrei prenotare una consulenza online gratuita.",
  anteprima: "Ciao Studio Web NS, vorrei vedere un’anteprima di come potrebbe diventare il sito della mia attività.",
};

export const waLink = (topic = "preventivo") =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGES[topic] || WA_MESSAGES.preventivo)}`;

export const DEFAULT_SEDI = [
  { city: "Milano", address: "Viale Monza 347, 20126 Milano (MI)", operative: true, by_appointment: true, services: "Consulenze e progettazione" },
  { city: "Como", address: "Via Pasquale Paoli 78, Como (CO)", operative: true, by_appointment: true, services: "Consulenze e progettazione" },
  { city: "Monza", address: "Via Monte San Primo 1, Monza (MB)", operative: true, by_appointment: true, services: "Consulenze e progettazione" },
];

export const NAV = [
  { label: "Servizi", to: "/servizi" },
  { label: "Soluzioni", to: "/soluzioni" },
  { label: "Portfolio e Demo", to: "/portfolio" },
  { label: "Prezzi", to: "/prezzi" },
  { label: "Chi siamo", to: "/chi-siamo" },
  { label: "Guide", to: "/guide" },
  { label: "Contatti", to: "/contatti" },
];

export const IMG = {
  bar: "https://images.unsplash.com/photo-1774029787812-6758a99eca67?auto=format&fit=crop&w=1200&q=70",
  parrucchieri: "https://images.unsplash.com/photo-1600948836101-f9ffda59d250?auto=format&fit=crop&w=1200&q=70",
  abbigliamento: "https://images.unsplash.com/photo-1558769132-cb1aea458c5e?auto=format&fit=crop&w=1200&q=70",
  botteghe: "https://images.unsplash.com/photo-1556970256-05e8a6edd190?auto=format&fit=crop&w=1200&q=70",
  showroom: "https://images.unsplash.com/photo-1680503397644-bcd216845f26?auto=format&fit=crop&w=1200&q=70",
  artigiani: "https://images.unsplash.com/photo-1608613304899-ea8098577e38?auto=format&fit=crop&w=1200&q=70",
  team: "https://images.unsplash.com/photo-1582005450386-52b25f82d9bb?auto=format&fit=crop&w=1400&q=70",
  desk: "https://images.unsplash.com/photo-1621856625680-282ec3a17db8?auto=format&fit=crop&w=1400&q=70",
};

export const PACKAGE_OPTIONS = { start: "Pacchetto Start", business: "Pacchetto Business", premium: "Pacchetto Premium", partner: "Digital Partner", "crm-start": "CRM Start", "crm-light": "CRM Personalizzato Light", "social-start": "Social Start", "social-business": "Social Business" };

export const SERVICE_OPTIONS = [
  ...Object.values(PACKAGE_OPTIONS), "Anteprima personalizzata", "Sito web", "Rifacimento sito", "Manutenzione e gestione", "Catalogo prodotti", "E-commerce", "CRM", "Gestione social", "SEO", "Non so ancora",
];
export const BUDGET_OPTIONS = ["Fino a 1.000 €", "1.000 – 2.500 €", "2.500 – 5.000 €", "Oltre 5.000 €", "Canone mensile", "Preferisco parlarne"];
export const TIME_OPTIONS = ["Mattina (9–13)", "Pomeriggio (14–18)", "Indifferente"];
